<template>
  <section id="no-student">
    <header></header>
    <section>
      <img :src="require('../../assets/img/logo_small_height.png')" alt="">
      <section v-html="$t('external.error.noAccess')"></section>
    </section>
    <footer></footer>
  </section>
</template>

<script>
export default {
  name: 'ProfileCreationError',
}
</script>

<style lang="scss" scoped>
  #no-student {
    display: grid;
    grid-template-rows: 56px 1fr 56px;
    height: 100vh;

    header, footer {
      background-color: #b00020;
    }

    > section {
      padding: 15px;

      img {
        width: 100%;
      }

      > section::v-deep {
        p {
          text-indent: 15px;
          font-size: 18px;
        }

        a {
          font-size: 18px;
        }
      }
    }
  }
</style>
